import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  displayNextSelect(event) {

    //Finding my next element
    let nextElementId = event.currentTarget.dataset.nextid
    let nextElement = document.getElementById(nextElementId)

    // Getting the selected value
    let options = event.target.options
    let selectedValue = options[options.selectedIndex].value

    // building the url
    let baseUrl = window.location.origin
    let pathUrl = event.currentTarget.dataset.url
    let url = new URL(`${baseUrl}/${pathUrl}/${selectedValue}`)

    let currentElement = event.currentTarget

    // ajax
    fetch(url)
      .then(response => response.json())
      .then((data) => {

        // enable next element input
        nextElement.disabled = false

        // list all elements that have data-location attribute
        let elements = document.querySelectorAll('[data-location]');

        // initial condition
        var deleteElement = false

        // loop to find the current Element and to empty the following ones
        elements.forEach( elem => {

          if(deleteElement == true) {
            elem.innerText = ''
          }

          if(elem == currentElement) {
            deleteElement = true;
          }

        })

        // adding each result as an option
        data.forEach( element => {
          let option = document.createElement('option')
          option.text = element.name
          option.value = element.id
          nextElement.appendChild(option)
        })
    })
     .catch(e => { /* Abort */ })
  }

  changeNextInputOnSelect(event){
    // Getting the selected value
    let options = event.target.options
    let selectedValue = options[options.selectedIndex].value

     // Getting the element to be changed
    let elementId = event.currentTarget.dataset.id
    let element = document.getElementById(elementId)

    // Changing the element
    element.value = selectedValue
  }
}


